function changeGroupField( endpointId, group, index, field, value, action ) {
	return {
		type: 'GROUP_FIELD_CHANGE',
		payLoad: {
			endpointId,
			group,
			index,
			field,
			value,
      action
		}
	}
}

export { changeGroupField };
